import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AuthService } from 'app/auth/auth.service';
import { DatePipe, formatDate } from '@angular/common';
import { ExportService } from 'app/reports/services/export.service';
import { OtherMoudleService } from '../othermodule.service';
import { expenseModal } from '../Model/otherModule.model';
import { MatSelect } from '@angular/material/select';
@Component({
  selector: 'app-daily-expenses-details',
  templateUrl: './daily-expenses-details.component.html',
  styleUrls: ['./daily-expenses-details.component.scss']
})
export class DailyExpensesDetailsComponent implements OnInit {

  branchControl: FormControl;
  filteredBranchArray: Observable<any[]>;
  accountData: any[] = []
  transactionData: any[] = []
  accountControl: FormControl;
  filteredAccountArray: Observable<any[]>
  selectedFinYear: string
  finYears = this.authService.FinYears
  startdate: any;
  selectedBranch: number;
  selectedFinyear: any;
  totalAmount: any = 0;
  selectedAccount: any;
  dailyExpense: expenseModal[] = []
  paymentsTotal: any = 0;
  receiptsTotal: any = 0;
  branchName: any;
  showSpinner: boolean = false;
  enabledisable: boolean = true;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;


  constructor(private otherService: OtherMoudleService,
    private authService: AuthService, private exportdata: ExportService, private datepipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.getaccountMaster();
    this.gettransactionType()
    this.selectedFinYear = this.finYears[0].displayFinYear;
    this.startdate = this.authService.localDate
    this.selectedBranch = this.authService.Loggeduser.branchid
    this.selectedFinyear = this.authService.Loggeduser.finyear
    this.branchName = this.authService.Loggeduser.branchname;
    this.initializeBranchControl();
    this.GetDailyExpensesByDateByFinYearByBranchId()
  }

  initializeBranchControl() {
    this.branchControl = new FormControl();
    this.filteredBranchArray = this.branchControl.valueChanges.pipe(
      startWith(""),
      map((branch) =>
        branch
          ? this.filterBranchFunction(branch)
          : this.authService.Branches.slice()
      )
    );
  }

  filterBranchFunction(name: string): any[] {
    return this.authService.Branches.filter((branch) =>
      branch.branchName.toLowerCase().includes(name.toLowerCase())
    );
  }

  getaccountMaster() {
    this.otherService.GetAccountMaster().subscribe((data: any) => {
      this.accountData = data;
      this.initializeaccountControl();
    });
  }
  initializeaccountControl() {
    this.accountControl = new FormControl();
    this.filteredAccountArray = this.accountControl.valueChanges.pipe(
      startWith(""),
      map((account) =>
        account
          ? this.filteraccountFunction(account)
          : this.accountData.slice()
      )
    );
  }

  filteraccountFunction(name: string): any[] {
    return this.accountData.filter((account) =>
      account.accountName.toLowerCase().includes(name.toLowerCase())
    );
  }


  GetDailyExpensesByFinYearIdByBranchIdByCrAccId() {
    this.otherService.GetDailyExpensesByFinYearIdByBranchIdByCrAccId(this.selectedFinyear, this.selectedBranch, this.selectedAccount).subscribe((data: any) => {
      this.totalAmount = data[0].amount
    });
  }
  clearAccountName(accname: any) {
    if (!accname) {
      this.totalAmount = 0;
    }
  }

  GetDailyExpensesByDateByFinYearByBranchId() {

   
    const formattedDate = formatDate(this.startdate, 'yyyy-MM-dd', 'en-US');
    this.otherService.GetDailyExpensesByDateByFinYearByBranchId(formattedDate, this.selectedFinyear, this.selectedBranch).subscribe((data: any) => {
      this.receiptsTotal = 0;
     this.paymentsTotal = 0;
      this.dailyExpense=[];
      if (data.length > 0) {
        data.map(item => item.isEditlocal = false);
        this.dailyExpense = data
        data.forEach((transaction: any) => {
          if (transaction.fK_TranTypeId == 1) {
            this.receiptsTotal += transaction.amount;
          } else if (transaction.fK_TranTypeId == 2) {
            this.paymentsTotal += transaction.amount;
          }
        });
      }
    });
  }

  onBranchSelected(event) {
    this.selectedBranch = event.id;
    this.branchName = event.value;
  }
  onDateChange(newDate: any): void {
    this.startdate = newDate;
  }
  onFinYearChange(newFinYear: string): void {
  }
  clearbranchName(bid: any) {
    if (!bid) {
      this.selectedBranch = 0;
    }
  }

  addNewExpenseRow() {

    if (this.dailyExpense.length > 0) {
      const lastExpense = this.dailyExpense[this.dailyExpense.length - 1];
      if (
        !lastExpense.fK_TranTypeId ||
        !lastExpense.fK_Dr_Acc_Id ||
        !lastExpense.fK_Cr_Acc_Id ||
        !lastExpense.amount ||
        !lastExpense.narration
      ) {
        this.otherService.openSnackBar('Please fill in all required fields before adding a new row.', 'OK');
        return;
      }
    }

    this.dailyExpense.push({
      pk_TransactionId: 0,
      FK_BranchId: this.selectedBranch,
      Fk_FinyearId: this.selectedFinyear,
      VoucherNo: null,
      VoucherDate: formatDate(this.startdate, 'yyyy-MM-dd', 'en-US'),
      fK_TranTypeId: null,
      fK_Dr_Acc_Id: null,
      fK_Cr_Acc_Id: null,
      amount: null,
      narration: '',
      createdBy: null,
      IsActive: true,
      IsEdit: false,
      isEditlocal:true
    });
   this.enabledisable=false;
    setTimeout(() => {
      this.focusFirstSelect();
    }, 0);
  }
  editData(index: any, type: any) {
    this.dailyExpense[index].isEditlocal = type == 0 ? true : false
    if(type == 0){
    this.dailyExpense[index].IsEdit = true;
    }
    this.enabledisable=false;
  }
  focusFirstSelect() {
    const firstSelect = this.matSelects.toArray()[this.matSelects.length - 3];
    if (firstSelect) {
      firstSelect.focus();
    }
  }

  onaccountSelected(event: any) {
    this.selectedAccount = event
    this.GetDailyExpensesByFinYearIdByBranchIdByCrAccId()
  }

  gettransactionType() {
    this.otherService.TRANSACTIONTYPEMASTER().subscribe((data: any) => {
      this.transactionData = data
    });
  }


  onTransactionTypeChange(event: any, index: number) {
    this.dailyExpense[index].fK_TranTypeId = event.value;
  }

  onaccountypeChange(event: any, index: number, type: any) {
    if (type == 1) {
      this.dailyExpense[index].fK_Dr_Acc_Id = event.value;
    }
    else if (type == 2) {
      this.dailyExpense[index].fK_Cr_Acc_Id = event.value;
    }
  }


  savedailyExpense(event) {

    if (this.validateExpenses()) {
      this.showSpinner = true
      if (Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(this.startdate, "yyyy-MM-dd").toString()) || this.authService.Loggeduser.usertypeid == 9) {
        const findblankdata = this.dailyExpense.filter(expense => {
          return (expense.fK_TranTypeId == null || expense.fK_TranTypeId == undefined) ||
            (expense.fK_Cr_Acc_Id == null || expense.fK_Cr_Acc_Id == undefined) ||
            (expense.fK_Dr_Acc_Id == null || expense.fK_Dr_Acc_Id == undefined) ||
            (expense.amount == null || expense.amount == undefined) ||
            expense.narration.trim() == '';
        });
        if (findblankdata.length == 0) {
          const validExpenses = this.dailyExpense
            .filter(expense => {
              return expense.fK_TranTypeId !== null && expense.fK_TranTypeId !== undefined &&
                expense.fK_Cr_Acc_Id !== null && expense.fK_Cr_Acc_Id !== undefined &&
                expense.fK_Dr_Acc_Id !== null && expense.fK_Dr_Acc_Id !== undefined &&
                expense.amount !== null && expense.amount !== undefined &&
                expense.narration.trim() !== '';
            })
            .map(expense => ({
              ...expense
            }));
          const newdata=validExpenses.filter(item=>item.pk_TransactionId ==0 || item.IsEdit==true);
          const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
          button.setAttribute('disabled', true);
          const payload = {
            InsertDailyExpensesDto: newdata
          }
          const isEditForFirstRecord = payload.InsertDailyExpensesDto[0]?.IsEdit;
          this.otherService.InsertDailyExpenses(payload).subscribe(
            (response: any) => {

              button.removeAttribute('disabled');
              if (response.statusCode == 1) {
                this.enabledisable = true;
                if (isEditForFirstRecord) {
                  this.otherService.openSnackBar('Record updated successfully', 'OK');
                  this.showSpinner = false

                } else {
                  this.otherService.openSnackBar('Record saved successfully', 'OK');
                  this.showSpinner = false
                }
                this.GetDailyExpensesByDateByFinYearByBranchId()
              }
            },
            (err) => {
                button.removeAttribute('disabled');
               this.enabledisable = false;
              if (err.status == 403) {
                this.otherService.openSnackBar("You Don't have Permission", "OK");
                this.showSpinner = false

              }
              else if (err.error.statusCode == 422) {
                this.otherService.openSnackBar(err.error.message, "OK");
                this.showSpinner = false

              }
              else {
                this.otherService.openSnackBar("API Failed", "OK");
                this.showSpinner = false
              }
            }
          );
        } else {
          this.showSpinner = false
          this.otherService.openSnackBar('All field are required', 'OK');
        }
      } else {
        this.showSpinner = false
        this.otherService.openSnackBar('Permission allowed for the current date.', 'OK');
      }
    }
    else {
      this.otherService.openSnackBar('Please fill in all required fields in each row', 'OK');
    }
  }

  returnvalue(transid: any) {
    return this.transactionData.length > 0 ? this.transactionData.filter(item => item.pK_Id == transid)[0]?.name : null;
  }
  returndebitAccname(id: any) {
    return this.accountData.length > 0 ? this.accountData.filter(item => item.pK_AccountId == id)[0]?.accountName : null;
  }
  apptexportexcel(): void {
    var printdata = [];
    if (this.dailyExpense.length > 0) {

      this.dailyExpense.forEach(item => {
        let payloaddata = {
          "TranType": this.returnvalue(item.fK_TranTypeId),
          "DebitAcCode": item.fK_Dr_Acc_Id,
          "DebitAcName": this.returndebitAccname(item.fK_Dr_Acc_Id),
          "CreditAcCode": item.fK_Cr_Acc_Id,
          "CreditAcName": this.returndebitAccname(item.fK_Cr_Acc_Id),
          "BillNo/Narration": item.narration,
          "Amount": item.amount,
          "CreatedBy": item.createdBy
        }
        printdata.push(payloaddata);
      })
    }

    let payload = [{ 'TranType': '' }, { 'TranType': '' }, {
      'TranType': 'Balance Amount:-',
      'DebitAcCode': this.totalAmount,
      'DebitAcName': 'Total Payment:-',
      'CreditAcCode': this.paymentsTotal,
      'CreditAcName': 'Total Receipt :-',
      'BillNo/Narration': this.receiptsTotal
    }];
    printdata = printdata.concat(payload)
    this.exportdata.exportArrayToExcel(printdata, 'DailyExpense')
  }


  validateExpenses(): boolean {
    let isValid = true;

    this.dailyExpense.forEach((expense) => {
      if (!expense.fK_TranTypeId || !expense.fK_Dr_Acc_Id || !expense.fK_Cr_Acc_Id ||
        !expense.amount || !expense.narration.trim()) {
        isValid = false;
        expense['isInvalid'] = true;
      } else {
        expense['isInvalid'] = false;
      }
    });

    return isValid;
  }


}
